import React from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen } from 'lucide-react';
import ebookImg from '../../assets/home/book.jpg';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full py-12 px-6 bg-[#F6FAFD]"> {/* Padding section réduit de 20 à 12 */}
      <div className="max-w-5xl mx-auto"> {/* Largeur max réduite de 6xl à 5xl */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden bg-[#0A1931] rounded-[2rem] flex flex-col md:flex-row items-center"
        >
          {/* Section Texte - Padding réduit */}
          <div className="flex-1 p-8 md:p-12 z-10 text-left">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/20 border border-blue-400/30 backdrop-blur-md mb-4"
            >
              <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
              <span className="text-blue-300 text-[10px] font-bold tracking-widest uppercase">Gratuit</span>
            </motion.div>

            <h2 className="text-white text-[28px] md:text-[34px] font-black leading-tight mb-4 font-inter">
              Le Guide Ultime de la <br />
              <span className="text-[#3b82f6]">Cybersécurité</span> pour les PME
            </h2>

            <p className="text-gray-400 text-sm md:text-base mb-8 max-w-md font-medium leading-relaxed">
              Apprenez les 10 gestes essentiels pour sécuriser votre entreprise contre 80% des cyberattaques. Expert-approved.
            </p>

            <div 
            onClick={()=>{navigate('/resources')}}
            className="flex flex-col sm:flex-row items-center gap-5">
              <motion.button 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:w-auto bg-[#3b82f6] hover:bg-blue-600 text-white px-6 py-3.5 rounded-xl font-bold text-sm flex items-center justify-center gap-3 transition-all shadow-lg shadow-blue-500/25"
              >
                <Download size={18} />
                Télécharger l'Ebook
              </motion.button>
              
              <div className="flex items-center gap-2 text-gray-500">
                <BookOpen size={16} />
                <span className="text-[12px] font-bold tracking-wide">Déjà +2500 téléchargements</span>
              </div>
            </div>
          </div>

          {/* Section Image - Taille réduite */}
          <div className="relative flex-1 flex justify-center items-center p-6 md:p-0 w-full h-full min-h-[300px]">
            <div className="absolute inset-0 bg-blue-500/5 blur-3xl rounded-full" />
            
            <motion.div 
              initial={{ rotate: 5, x: 30, opacity: 0 }}
              whileInView={{ rotate: -2, x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="relative z-20 group"
            >
              <div className="absolute inset-0 bg-black/40 blur-2xl translate-y-6 scale-90" />
              
              <img 
                src={ebookImg} 
                alt="Guide Cybersécurité" 
                className="w-48 md:w-60 h-auto rounded-lg shadow-2xl border border-white/10 relative z-20 transform group-hover:-translate-y-2 transition-transform duration-500"
              />
            </motion.div>

            <div className="absolute top-1/2 right-0 w-48 h-48 bg-blue-500/10 rounded-full blur-[80px] -z-10" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;